import React, { Component } from "react";
import { connect } from "react-redux";

import { createRateLimit } from "actions/rateLimit";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/RateLimit/Form";

class RateLimitCreate extends Component {
  handleFormSubmit = data => {
    this.createRateLimit(data);
  };

  createRateLimit(data) {
    const { toggleNotification, toggleFullPageSpinner, createRateLimit, history } = this.props;
    toggleFullPageSpinner(true);
    createRateLimit(data)
      .then(() => {
        toggleNotification(true, { message: "Created RateLimit Success", infoClassName: "is-success" });
        history.push(`/rate-limits`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createRateLimit,
    toggleFullPageSpinner,
    toggleNotification
  }
)(RateLimitCreate);



// WEBPACK FOOTER //
// ./src/pages/RateLimit/Create/index.js